import { config } from "./config";

export interface IImageData {
    fullscreen: string;
    title: string;
    description: string;
}
interface IRelatedImage {
    fileName: string;
    storedFileName: string;
    title?: string;
    description?: string;
}

const baseUrl = config.images.url;

/**
 * Returns an array of available images data for object
 * @param objectId - OBJECTID field value
 * @param isRouteObject - optional boolean flag. Use True for Route objects, to get correct images
 */
export const getRelatedImages = (objectId: number, isRouteObject?: boolean): Promise<IImageData[]> => {
    return getRelatedImagesData(objectId, isRouteObject).then(
        (result) => {
            const relatedImages = result as IRelatedImage[];
            if (!relatedImages?.length) {
                return undefined;
            }
            return relatedImages.map((image: IRelatedImage) => {
                const imageData: IImageData = {
                    fullscreen: baseUrl + "GetImage?file=" + image.storedFileName,
                    title: image.title,
                    description: image.description
                };
                return imageData;
            });
        },
        (error) => {
            return undefined;
        }
    );
};

const getRelatedImagesData = async (objectId: number, isRouteObject?: boolean) => {
    return await fetch(getUrl(objectId, isRouteObject))
        .then((response) => response.json())
        .then((data) => data)
        .catch((error) => error);
};

const getUrl = (objectId: number, isRouteObject?: boolean) => {
    return (
        config.images.url +
        "GetRelatedImages?RelatedObjectId=" +
        objectId +
        "&Layer=" +
        (isRouteObject ? config.images.routeLayerBrowseName : config.images.layerBrowseName) +
        "&FileTable=" +
        (isRouteObject ? config.images.routeFileTableName : config.images.fileTableName)
    );
};
